import { render } from "./GatesDetail.vue?vue&type=template&id=691f82c8&scoped=true"
import script from "./GatesDetail.vue?vue&type=script&lang=js"
export * from "./GatesDetail.vue?vue&type=script&lang=js"

import "./GatesDetail.vue?vue&type=style&index=0&id=691f82c8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691f82c8"]])

export default __exports__